<template>
    <div>
        <!-- ---------------------------一級導覽列開始--------------------------- -->
        <nav class="navbar navbar-expand-md navbar-dark fixed-top py-0 cm-navbar">
            <div id="cm-navbar-container" class="container-fluid px-md-2">
                <a id="cm-logoM" class="navbar-brand d-lg-none" href="/">
                    <img src="../assets/images/cmi_logo.png" class="cm-navbar-brand">
                </a>
                <button class="navbar-toggler justify-content-around" type="button" data-toggle="collapse" data-target="#cm-navbar-button" aria-controls="cm-navbar-button" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse justify-content-center" id="cm-navbar-button">
                    <div class="col-1 d-none d-lg-block">
                        <a id="cm-logo" class="cm-navbar-brand-pc navbar-brand" href="/">
                            <img src="../assets/images/cmi_logo.png" class="cm-navbar-brand">
                        </a>
                    </div>
                    <div class="col-auto px-0">
                        <ul class="navbar-nav cm-navbar-dropdown-listener">
                            <li v-if="!isQuickDeposit" class="my-2 my-md-0 nav-item text-center cm-navbar-item-lg-width">
                                <router-link  class="py-md-3 py-1 nav-link" to="/">{{$t('header.nav.Home')}}</router-link>
                            </li>
                            <li v-if="!isQuickDeposit" class="d-md-block d-none">
                                <span class="py-3 nav-link px-1 px-lg-auto text-white">|</span>
                            </li>
                            <li v-if="!isQuickDeposit" class="my-2 my-md-0 nav-item text-center cm-navbar-item-lg-width">
                                <router-link  class="py-md-3 py-1 nav-link" :to="routerGame">{{$t('header.nav.Game')}}</router-link>
                            </li>
                            <li v-if="!isQuickDeposit" class="d-md-block d-none">
                                <span class="py-3 nav-link px-1 px-lg-auto text-white">|</span>
                            </li>
                            <li v-if="!isQuickDeposit" class="my-2 my-md-0 nav-item text-center dropdown cm-navbar-item-lg-width">
                                <router-link  class="py-md-3 py-1 nav-link" :to="routerNews">{{$t('header.nav.News')}}</router-link>
                            </li>
                            <li v-if="!isQuickDeposit" class="d-md-block d-none">
                                <span class="py-3 nav-link px-1 px-lg-auto text-white">|</span>
                            </li>
                            <li class="my-2 my-md-0 nav-item text-center cm-navbar-item-lg-width" v-if="showSupport && !isQuickDeposit">
                                <router-link :to="routerDeposit" class="py-md-3 py-1 nav-link dropdown-toggle cm-navbar-dropdown-trigger" 
                                data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{$t('header.nav.Deposit')}}</router-link>
                                <div class="dropdown-menu d-md-none cm-navbar-dropdown-list">
                                    <router-link :to="routerDeposit" :data-to=routerDeposit class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.TopUp')}}</router-link>
                                    <router-link :to="routerCodapay" :data-to=routerCodapay class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.Codapay')}}</router-link>
                                    <router-link :to="routerDeposithistorylist" :data-to=routerDeposithistorylist class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.DepositHistoryList')}}</router-link>
                                    <router-link :to="routerInvoice" :data-to=routerInvoice class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.Invoice')}}</router-link>
                                    <!--
                                    <router-link :to="routerGiftCode" :data-to=routerGiftCode class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.GiftCode')}}</router-link>
                                    -->
                                </div>
                            </li>
                            <li class="d-md-block d-none"  v-if="showSupport && !isQuickDeposit">
                                <span class="py-3 nav-link px-1 px-lg-auto text-white">|</span>
                            </li>
                            <li class="my-2 my-md-0 nav-item text-center cm-navbar-item-lg-width" v-if="showShop && !isQuickDeposit">
                                <router-link :to="routerDeposit" class="py-md-3 py-1 nav-link dropdown-toggle cm-navbar-dropdown-trigger" 
                                data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">SHOP</router-link>
                                <div class="dropdown-menu d-md-none cm-navbar-dropdown-list">
                                    <!--
                                    <router-link :to="routerTopup" :data-to=routerTopup class="px-md-3 px-sm-2 px-1 d-flex align-items-center cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.TopUp')}}</router-link>
                                    <router-link :to="routerCodapay" :data-to=routerCodapay class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">
                                        <div>
                                            <div class="d-flex justify-content-center">{{$t('header.nav.Deposit.codapay.en.Text1')}}</div>
                                            <div>{{$t('header.nav.Deposit.codapay.en.Text2')}}</div>
                                        </div>
                                    </router-link>
                                    -->
                                    <router-link :to="routerDeposit" :data-to=routerDeposit class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.TopUp')}}</router-link>
                                    <router-link :to="routerCodapay" :data-to=routerCodapay class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.Codapay')}}</router-link>
                                    <router-link :to="routerDeposithistorylist" :data-to=routerDeposithistorylist class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.DepositHistoryList')}}</router-link>
                                    <!--
                                    <router-link :to="routerGiftCode" :data-to=routerGiftCode class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Deposit.GiftCode')}}</router-link>
                                    -->
                                </div>
                            </li>
                            <li class="d-md-block d-none"  v-if="showShop && !isQuickDeposit">
                                <span class="py-3 nav-link px-1 px-lg-auto text-white">|</span>
                            </li>
                            <li v-if="!isQuickDeposit" class="my-2 my-md-0 nav-item text-center cm-navbar-item-lg-width">
                                <!-- <a v-if="!zendeskEn" href="https://all9funsupport.zendesk.com/hc" class="py-md-3 py-1 nav-link dropdown-toggle cm-navbar-dropdown-trigger" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{$t('header.nav.ContactUs')}}</a> -->
                                <router-link  v-if="loginAccount!==''" :to="routerContactus" class="py-md-3 py-1 nav-link dropdown-toggle cm-navbar-dropdown-trigger" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{$t('header.nav.ContactUs')}}</router-link>
                                <router-link  v-if="loginAccount===''" :to="routerDownload" class="py-md-3 py-1 nav-link dropdown-toggle cm-navbar-dropdown-trigger" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{$t('header.nav.ContactUs')}}</router-link>
                                <div class="dropdown-menu d-md-none cm-navbar-dropdown-list">
                                    <!-- <a v-if="zendeskTW" href="https://all9funsupport.zendesk.com/hc" class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Faq')}}</a> -->
                                    <!-- <a v-else-if="zendeskCN " href="https://all9fun-cn.zendesk.com/hc" class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Faq')}}</a> -->
                                    <!-- <a v-else href="https://all9fun-en.zendesk.com/hc" class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Faq')}}</a> -->
                                    <router-link :to="routerFaq" :data-to=routerFaq class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.Faq')}}</router-link>
                                    <router-link :to="routerContactus" :data-to=routerContactus class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.ContactUs.ReportProblem')}}</router-link>
                                    <router-link :to="routerHistorylist" :data-to=routerHistorylist class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.ContactUs.HistoryList')}}</router-link>
                                    <router-link :to="routerDownload" :data-to=routerDownload class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color">{{$t('header.nav.ContactUs.Download')}}</router-link>
                                </div>
                            </li>
                            <li v-if="!isQuickDeposit" class="d-md-block d-none">
                                <span class="py-3 nav-link px-1 px-lg-auto text-white">|</span>
                            </li>
                            <li v-if="!isQuickDeposit" class="my-2 my-md-0 nav-item text-center cm-navbar-item-lg-width">
                                <a class="py-md-3 py-1 nav-link dropdown-toggle cm-navbar-dropdown-trigger" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{{$t('header.nav.Language')}}</a>
                                <div class="dropdown-menu d-md-none cm-navbar-dropdown-list" @click="clientSetLanguage">
                                    <a href="#" class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color" data-language="zh-TW">{{$t('header.nav.Language.tw')}}</a>
                                    <a href="#" class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color" data-language="zh-CN">{{$t('header.nav.Language.cn')}}</a>
                                    <a href="#" class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color" data-language="en-US">{{$t('header.nav.Language.en')}}</a>
                                    <a href="#" class="px-md-3 px-sm-2 px-1 cm-navbar-dropdown-item-color" data-language="ja">{{$t('header.nav.Language.ja')}}</a>
                                </div>
                            </li>
                            <li v-if="loginAccount===''" class="my-2 my-md-0 nav-item d-block d-md-none text-center cm-navbar-item-lg-width">
                                <a id="loginModalHyperlink" class="nav-link py-1" href="#" data-toggle="modal" data-target="#loginModal">{{$t('header.nav.SignIn')}}</a>
                            </li>
                            <li v-if="loginAccount==='' && !isQuickDeposit" class="my-2 my-md-0 nav-item d-block d-md-none text-center cm-navbar-item-lg-width">
                                <a class="nav-link py-1" href="#" data-toggle="modal" data-target="#registerModal">{{$t('header.nav.Register')}}</a>
                            </li>
                            <li id="memberInfo" v-if="loginAccount!==''" class="my-2 my-md-0 nav-item d-block d-md-none text-center cm-navbar-item-lg-width">
                                <a class="nav-link py-1" href="#" data-toggle="modal" data-target="#memberModal">{{$t('header.nav.Information')}}</a>
                            </li>
                            <li v-if="loginAccount!=='' && !isQuickDeposit" class="my-2 my-md-0 nav-item d-block d-md-none text-center cm-navbar-item-lg-width">
                                <a @click="logoutService" class="nav-link py-1">{{$t('header.nav.Logout')}}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="form-inline cm-login-register d-none d-md-block">
                        <img src="@/assets/images/home/sign.png">&nbsp;
                        <a href="#" data-toggle="modal" data-target="#loginModal" v-if="loginAccount===''">{{$t('header.nav.SignIn')}}</a>
                        <a href="#" data-toggle="modal" data-target="#memberModal" v-if="loginAccount!==''">{{$t('header.nav.Information')}}</a>
                        <span class="px-1" v-if="!isQuickDeposit"> | </span>
                        <a href="#" data-toggle="modal" data-target="#registerModal" v-if="loginAccount==='' && !isQuickDeposit">{{$t('header.nav.Register')}}</a>
                        <a href="#" @click="logoutService" v-if="loginAccount!=='' && !isQuickDeposit">{{$t('header.nav.Logout')}}</a>
                    </div>
                </div>
            </div>
        </nav>
        <!-- ---------------------------一級導覽列結束--------------------------- -->



        <!-- ---------------------------二級導覽列開始--------------------------- -->
        <div id="cm-navbar-dropdown-bar" class="d-none d-md-block" data-hide="true">
            <div class="cm-navbar-dropdown-bar-gaps"></div>
            <div class="cm-navbar-dropdown-bar-space">
                <div id="cm-navbar-dropdown-container" @click="clickSecondNavbar($event)">
                </div>
            </div>
        </div>
        <!-- ---------------------------二級導覽列結束--------------------------- -->

    </div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import router from '@/router'
import {cm_navbar_initial,cm_navbar_dynamic_dropdown_container_position,cm_navbar_mobile_init,cm_navbar_mobile_overflowy_detect,cm_navbar_mobile_close} from '@/assets/js/cm-navbar.js'
import store from '@/store/store-controller/store.js'
import CookieUtil from "@/assets/js/util/CookieUtil.js"
import * as BackendSetting from "@/assets/js/util/BackendSetting.js"
import eventBus from '@/assets/js/event/EventBus.js'
import { mapGetters } from 'vuex'
import * as i18n from '@/i18n/i18n-controller/i18n.js'
import {check} from '@/filter.js'

export default {
    data() {
        return {
            showSupport: false,
            showShop: true,
            loginAccount: "",
            routerGame: process.env.VUE_APP_ROUTER_GAME,
            routerNews: process.env.VUE_APP_ROUTER_NEWS,
            routerDeposit: process.env.VUE_APP_ROUTER_DEPOSIT,
            routerTopup: process.env.VUE_APP_ROUTER_TOPUP,
            routerCodapay: process.env.VUE_APP_ROUTER_CODAPAY,
            routerDeposithistorylist: process.env.VUE_APP_ROUTER_DEPOSIT_HISTORY_LIST,
            routerInvoice: process.env.VUE_APP_ROUTER_INVOICE,
            routerGiftCode: process.env.VUE_APP_ROUTER_GIFTCODE,
            routerContactus: process.env.VUE_APP_ROUTER_CONTACT_US,
            routerDownload: process.env.VUE_APP_ROUTER_DOWNLOAD,
            routerHistorylist: process.env.VUE_APP_ROUTER_HISTORY_LIST,
            routerFaq: process.env.VUE_APP_ROUTER_FAQ,
            routerFaqNew: process.env.VUE_APP_ROUTER_FAQ_NEW,
            routerQuickDeposit: process.env.VUE_APP_ROUTER_QUICKDEPOSIT,
            eventBus: {
                verifyLogin: { // [事件]驗證登入狀態
                    verifyStatus: false,                // true: 驗證登入
                    from: null,                         // 來源頁面
                    setFrontendRouterPushCookie: false, // true: 設置cookie方便登入會導回from設置的頁面
                    showLoginModal: false,              // true: 未登入狀態下顯示loginModal
                    setCookie: {}                       // 是否要set其他cookie，沒有保持空
                }
            },
            isQuickDeposit : false,
            zendeskTW : false,
            zendeskCN : false,
        }
    },
    methods: {
        updateLoginAccount() {
            if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false) {
                let self = this;
                let bodyFormData = new FormData();
                bodyFormData.append("allMemberMultiIdKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                
                axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getMemberAccountAction.shtml",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    data: bodyFormData,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .then(function(response) {
                    if(response.data.result==="success") {
                        self.loginAccount = response.data.account;
                        if(response.data.consigneeCode=="@google" || response.data.consigneeCode=="@fb") {
                            self.loginAccount = response.data.gameAccount;
                        }
                        else {
                            self.loginAccount = response.data.account;
                        }
                        
                        store.dispatch('storeMemberInfo/actionSetNum', response.data.num);
                        store.dispatch('storeMemberInfo/actionSetMainPk', response.data.mainPk);
                        store.dispatch('storeMemberInfo/actionSetAccount', response.data.account);
                        store.dispatch('storeMemberInfo/actionSetGameAccount', response.data.gameAccount);
                        store.dispatch('storeMemberInfo/actionSetConsigneeCode', response.data.consigneeCode);
                        
                        // 如帳號未綁定信箱，API中的email欄位會回傳字串null
                        if(response.data.email=="null" || response.data.email==null 
                            || response.data.email=="" || response.data.email==undefined) {
                            store.dispatch('storeMemberInfo/actionSetEmail', null);
                        }
                        else {
                            store.dispatch('storeMemberInfo/actionSetEmail', response.data.email);
                        }

                        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_REFRESH_MEMBER_INFO_WHEN_GET_MEMBER_ACCOUNT_INFO);

                        // 判斷是否有特定cookie，如果有將玩家轉到該頁面
                        if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ROUTER_PUSH)) {                            
                            const routerPush = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ROUTER_PUSH);
                            CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_FRONTEND_ROUTER_PUSH)
                            if(routerPush == process.env.VUE_APP_ROUTER_DEPOSIT) {
                                router.push({name: process.env.VUE_APP_ROUTER_DEPOSIT});
                            }
                            else if(routerPush == process.env.VUE_APP_ROUTER_TOPUP) {
                                router.push({name: process.env.VUE_APP_ROUTER_TOPUP});
                            }
                            else if(routerPush == process.env.VUE_APP_ROUTER_CODAPAY) {
                                router.push({name: process.env.VUE_APP_ROUTER_CODAPAY});
                            }
                            else if(routerPush == process.env.VUE_APP_ROUTER_CONTACT_US) {
                                router.push({name: process.env.VUE_APP_ROUTER_CONTACT_US});
                            }
                            else if(routerPush == process.env.VUE_APP_ROUTER_HISTORY_LIST) {
                                let pushObj = {};
                                pushObj.name = process.env.VUE_APP_ROUTER_HISTORY_LIST;
                                pushObj.query = {};
                                if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_HISTORYLIST_QUERY_CS)) {
                                    let cs = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_HISTORYLIST_QUERY_CS);
                                    CookieUtil.commonDeleteCookie(process.env.VUE_APP_COOKIE_HISTORYLIST_QUERY_CS);
                                    if((parseInt(cs)==cs) && parseInt(cs)>0) {
                                        pushObj.query.cs = cs;
                                    }
                                }
                                router.push(pushObj);
                            }
                            else if(routerPush == process.env.VUE_APP_ROUTER_DEPOSIT_HISTORY_LIST) {
                                router.push({name: process.env.VUE_APP_ROUTER_DEPOSIT_HISTORY_LIST});
                            }
                            else if(routerPush == process.env.VUE_APP_ROUTER_INVOICE) {
                                router.push({name: process.env.VUE_APP_ROUTER_INVOICE});
                            }
                            else if(routerPush == process.env.VUE_APP_ROUTER_GIFTCODE) {
                                router.push({name: process.env.VUE_APP_ROUTER_GIFTCODE});
                            }else if(routerPush == process.env.VUE_APP_ROUTER_QUICKDEPOSIT) {
                                let pushObj = {};
                                pushObj.name = process.env.VUE_APP_ROUTER_QUICKDEPOSIT;
                                pushObj.query = {};
                                if (CookieUtil.getCookie(process.env.VUE_APP_COOKIE_QUICKDEPOSIT_GAMECODE)){
                                    let gc = CookieUtil.getCookie(process.env.VUE_APP_COOKIE_QUICKDEPOSIT_GAMECODE);
                                    pushObj.query.gameCode = gc;
                                }
                                router.push(pushObj);
                            }
                        }
                    }
                    else {
                        self.logoutStep();
                        if(self.eventBus.verifyLogin.verifyStatus == true) {
                            self.subsequentVerifyLoing();
                        }
                        else {
                            router.push({name: process.env.VUE_APP_ROUTER_HOME});
                        }
                    }
                })
                .catch(function(response) {
                    console.log(response);
                    console.log(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                })
            }
            else {
                this.logoutStep();
                this.subsequentVerifyLoing();
            }
        },
        subsequentVerifyLoing() {
            if(this.eventBus.verifyLogin.verifyStatus == true) {
                // 未登入狀態先導回首頁，簡易儲值則留在原頁面待玩家登入                
                if (this.eventBus.verifyLogin.from != process.env.VUE_APP_ROUTER_QUICKDEPOSIT){
                    router.push({name: process.env.VUE_APP_ROUTER_HOME}).catch(function(err) {});
                }
                
                
                // 復原
                this.eventBus.verifyLogin.verifyStatus = false;

                // 取值
                const setFrontendRouterPushCookie = this.eventBus.verifyLogin.setFrontendRouterPushCookie;
                const from = this.eventBus.verifyLogin.from;
                const showLoginModal = this.eventBus.verifyLogin.showLoginModal;
                const setCookie = this.eventBus.verifyLogin.setCookie;

                // 復原值
                this.eventBus.verifyLogin.setFrontendRouterPushCookie = false;
                this.eventBus.verifyLogin.from = false;
                this.eventBus.verifyLogin.showLoginModal = false;
                this.eventBus.verifyLogin.setCookie = {}

                if(setFrontendRouterPushCookie == true) {
                    CookieUtil.commonSetCookie(process.env.VUE_APP_COOKIE_FRONTEND_ROUTER_PUSH, from);
                }

                if(Object.keys(setCookie).length > 0) {
                    for(let key in setCookie) {
                        CookieUtil.commonSetCookie(key, setCookie[key]);
                    }
                }

                if(showLoginModal == true) {
                    if(from == process.env.VUE_APP_ROUTER_HOME || from == process.env.VUE_APP_ROUTER_QUICKDEPOSIT) {
                        cm_navbar_mobile_close(); // 關閉手機版展開中的navbar
                        document.querySelector("#loginModalHyperlink").click();
                    }
                    else {
                        router.push({name: process.env.VUE_APP_ROUTER_HOME, query: {action: "login"}})
                    }
                }
            }
        },
        pageOnLoad() {
            // 初始化導覽列JS
            cm_navbar_initial();
            
            // 初始化手機版navbar
            cm_navbar_mobile_init();

            // 防止捲軸超出畫面，無法正確且完整顯示一級導覽列所有項目
            window.addEventListener("orientationchange" in window ? "orientationchange" : "resize", function () {
                cm_navbar_mobile_overflowy_detect();
            }, false);
        },
        handleResize() {
            // 二級導覽列常駐時(如平板)動態位置判斷
            cm_navbar_dynamic_dropdown_container_position();
        },
        SwitchSupportView()
        {
            if(store.getters['storeI18n/getNowLanguage']=='zh-TW'
            || store.getters['storeI18n/getNowLanguage']=='zh-CN')
            {
                this.showSupport = true;
                this.showShop = false;
                if (store.getters['storeI18n/getNowLanguage']=='zh-TW'){
                    this.zendeskTW = true;
                    this.zendeskCN = false;
                }else{
                    this.zendeskTW = false;
                    this.zendeskCN = true;
                }
                check();
            }
            else
            {
                this.showSupport = false;
                this.showShop = true
                this.zendeskTW = false;
                this.zendeskCN = false;
                check();
            }
        },
        clickSecondNavbar(event) {
            // 解決IE11點選二級導覽列無反應問題
            if(navigator.userAgent.indexOf("Trident") > -1) {
                router.push({name: event.target.dataset.to})
            }

            this.clientSetLanguage(event);
        },
        async clientSetLanguage(event) {
            const beforeModifyLanguage = this.$i18n.locale; // 記錄下更改前的語系
            if(event.target.dataset.language!=undefined) {
                i18n.loadLanguageAsync(event.target.dataset.language);

                // 判斷更改前與更改後的語系是否相同
                let isEnforceChange = false
                if(beforeModifyLanguage != this.$i18n.locale) {
                    isEnforceChange = true
                }

                i18n.whenChangeLanguage(this.$i18n, isEnforceChange);
                event.preventDefault();
            }
        },
        logoutService() {
            if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE)!==false) {
                const self = this;
                let bodyFormData = new FormData();
                bodyFormData.append("logoutKey", CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE));
                axios({
                    method: "post",
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/memberLogoutAction.shtml",
                    data: bodyFormData,
                    config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
                })
                .then(function(response) {
                    if(response.data==="success") {
                        self.logoutStep();
                        if(router.currentRoute.name != process.env.VUE_APP_ROUTER_HOME) {
                            if (router.currentRoute.name == process.env.VUE_APP_ROUTER_QUICKDEPOSIT){
                                //簡易儲值不需要跳頁避免把玩家丟回home
                                //頁面本身重新init即可
                            }else{
                                router.push({name: process.env.VUE_APP_ROUTER_HOME});
                            }
                        }
                    }
                })
                .catch(function(response) {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                })
            }
        },
        logoutStep() {
            this.loginAccount = "";
            CookieUtil.logoutAccount();
            store.dispatch('storeMemberInfo/actionSetNum', "");
            store.dispatch('storeMemberInfo/actionSetMainPk', "");
        }
    },
    created() {
        this.SwitchSupportView();
        window.addEventListener("resize", this.handleResize);
        this.updateLoginAccount();      
    },
    mounted() {   
        const self = this;
        this.pageOnLoad();

        // 更換語言時
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_CHANGE_HEADER, function(i18n) {
            self.SwitchSupportView();
        })

        // 登出
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_MEMBER_LOGOUT, function() {
            self.logoutService();
        });

        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , function(isQuickDeposit) {
            self.isQuickDeposit = isQuickDeposit;
        });
        
        // 驗證登入狀態
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_VERIFY_LOGIN, function(verifySetting) {
            if(verifySetting!=undefined && verifySetting.verifyStatus != undefined && verifySetting.verifyStatus == true) {
                self.eventBus.verifyLogin.verifyStatus = verifySetting.verifyStatus;
                // 發起事件頁面
                if(verifySetting.from != undefined && verifySetting.from != "") {
                    self.eventBus.verifyLogin.from = verifySetting.from;
                }
                else {
                    self.eventBus.verifyLogin.from = null;
                }
                // 是否要設置cookie，登入後根據此cookie導回發起事件頁面
                if(verifySetting.setFrontendRouterPushCookie != undefined && verifySetting.setFrontendRouterPushCookie == true) {
                    self.eventBus.verifyLogin.setFrontendRouterPushCookie = verifySetting.setFrontendRouterPushCookie;
                }
                else {
                    self.eventBus.verifyLogin.setFrontendRouterPushCookie = false;
                }
                // 如果未登入狀態，是否自動開啟loing modal
                if(verifySetting.showLoginModal != undefined && verifySetting.showLoginModal == true) {
                    self.eventBus.verifyLogin.showLoginModal = verifySetting.showLoginModal;
                }
                else {
                    self.eventBus.verifyLogin.showLoginModal = false;
                }
                // 是否要設置cookie
                if(verifySetting.setCookie != undefined
                 && verifySetting.setCookie instanceof Object
                 && Object.keys(verifySetting.setCookie).length > 0) {
                    self.eventBus.verifyLogin.setCookie = verifySetting.setCookie;
                }
                else {
                    self.eventBus.verifyLogin.setCookie = {};
                }

                self.updateLoginAccount();
            }
        });
        
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
}
</script>